<section class="relative overflow-visible rounded-lg bg-white dark:bg-gray-800">
  <app-loading-spinner *ngIf="isLoading" [isFullScreen]="false"></app-loading-spinner>
  <table class="w-full text-sm text-left rounded-lg text-gray-500 dark:text-gray-400">
    <thead class="text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
      <ng-container *ngIf="headerTemplate">
        <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      </ng-container>
    </thead>
    <tbody *ngIf="value && value.length; else noElementsToShow">
      <ng-container *ngFor="let item of value; trackBy: trackByItem">
        <ng-template [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
      </ng-container>
    </tbody>
    <ng-template #noElementsToShow>
      <ng-template [ngTemplateOutlet]="emptyMessageTemplate"></ng-template>
    </ng-template>
  </table>
  <app-system-paginator
    *ngIf="paginator && value && value.length"
    [currentPage]="currentPage"
    [itemsPerPage]="10"
    [totalItems]="totalItems"
    (pageChanged)="onPageChanged($event)"
  ></app-system-paginator>
</section>
